/* eslint-disable */
export default {
  data: () => ({
    isResponsible: false
  }),
  methods: {
    methodGeneralSocket (item) {},
    beforeAddSocketItem (item) {},
    afterAddSocketItem (item) {},
    beforeDeleteSocketItem (item) {},
    beforeEditSocketItem (item) {},
    beforeAddSocketItemDetails (item) {},
    beforeEditSocketItemDetails (item) {},
    beforeDeleteSocketItemDetails (item) {},
    beforeReloadPageModules (item) {},
    beforeSocketSnackbar (item) {},
    afterSocketSnackbar (item) {},
    recursiveAddSubTask (item, task, treeSequence, i = 0) {
      if (item.task_id === treeSequence[i]) {
        if (task.all_subtasks.length === task.subtasks_clean_count) {
          task.all_subtasks.push(item)
        }
        this.changeSubtasksCount(item, 'add')
        this.reloadFilter()
      } else {
        var nextTask = task.all_subtasks.find((val) => {
          return val.id === treeSequence[i + 1]
        })
        // if (item.task_id === treeSequence[i + 1]) {
        //     this.changeSubtasksCount(item, 'add')
        //     this.redoFilter()
        // }
        if (nextTask) {
          this.recursiveAddSubTask(item, nextTask, treeSequence, i + 1)
        }
      }
    },
    recursiveDeleteSubTask (item, task, treeSequence, i = 0) {
      // encontra a tarefa mãe da tarefa apagada
      if (item.task_id === treeSequence[i]) {
        // verifica se a tarefa apagada tinha status de finalizada
        if (item['status'] && item['status']['identifier'] === 3) {
          // caso tenha status de finalizada então deve subtrair 1 nas tarefa finalizadas da mãe
          task['finalized_subtasks']--
        }
        if (task.all_subtasks.length === task.subtasks_clean_count) {
          const itemIndex = task.all_subtasks.findIndex((element) => {
            return element.id === item.id
          })
          task.all_subtasks.splice(itemIndex, 1)
        }
        this.changeSubtasksCount(item, 'del')
        this.reloadFilter()
      } else {
        var nextTask = task.all_subtasks.find((val) => {
          return val.id === treeSequence[i + 1]
        })
        // if (item.task_id === treeSequence[ i + 1]) {
        //     this.changeSubtasksCount(item, 'del')
        //     this.redoFilter()
        // }
        if (nextTask) {
          this.recursiveDeleteSubTask(item, nextTask, treeSequence, i + 1)
        }
      }
    },
    recursiveEditSubTask (item, task, treeSequence, i = 0) {
      // all_subtasks nem sempre tem, exemplo kanban
      if ((item.task_id === treeSequence[i]) && task.all_subtasks) {
        if (task.all_subtasks.length === task.subtasks_clean_count) {
          let findItem = task.all_subtasks.find((element) => {
            return element.id === item.id
          })
          if (findItem) {
            Object.assign(findItem, item)
            // this.reloadFilter()
          }
        }
      } else {
        var nextTask = task.all_subtasks.find((val) => {
          return val.id === treeSequence[i + 1]
        })
        if (nextTask) {
          this.recursiveEditSubTask(item, nextTask, treeSequence, i + 1)
        }
      }
    },
    // criado o method para ser reutilizados quando adiciona subtarefa
    methodAddSocketItem (task) {
      if (this.$refs.boards && this.$refs.boards.verifyInFilter(task)) {
        // Se for kanban adicionar no status referente
        if (this.individualFilter['properties']['exibitionType'] && this.individualFilter['properties']['exibitionType'] === 2) {
          let status = this.$refs.kanban.allStatus.find(st => st.id_text === task.status.id_text)
          if (status) {
            // uma verificação caso já exista algum item com aquele id, para não adicionar duplicado. Pois no methodEditTaskSocket do methodtaskSocket ao editar pode mandar um socket para adicionar e depois um de editar que pode acabar adicionando no kanabn 
            let index = status.items.findIndex(it => it.id === task.id)
            if (index == -1) {
              status.items.unshift(task)
              status.total = status.total + 1
            }
          }
        //Caso não seja kanban adiciona nos items normal
        } else {
          this.items.unshift(task)
        }
      }
    },
    methodEditSocketItem (task) {
      // caso seja o kanban e o level do filtro seja o listar tarefas e subs ou o level da tarefa estaja de acordo com o level do filtro já edita direto
      if (this.individualFilter['properties']['exibitionType'] && this.individualFilter['properties']['exibitionType'] === 2 && (this.individualFilter['properties']['showTaskLevel'] == 0 || (this.individualFilter['properties']['showTaskLevel'] == 1 && task['level'] === 1) || (this.individualFilter['properties']['showTaskLevel'] == 2 && task['level'] > 1))) {
        // O verify vem depois pois ele pode gastar mais processamento que o find do else, e no find se não encontrar não precisa editar
        if (this.$refs.boards && this.$refs.boards.verifyInFilter(task)) {
          if (task.old_status['id_text'] != task.status.id_text) {
            let oldStatus = this.$refs.kanban.allStatus.find(st => st.id_text === task.old_status['id_text'])
            if (oldStatus) {
              oldStatus.items = oldStatus.items.filter(val => val.id !== task.id)
              oldStatus.total = oldStatus.total - 1
            }
            let newStatus = this.$refs.kanban.allStatus.find(st => st.id_text === task.status.id_text)
            if (newStatus) {
              // uma verificação caso já exista algum item com aquele id, para não adicionar duplicado. Pois no methodEditTaskSocket do methodtaskSocket ao editar pode mandar um socket para adicionar e depois um de editar que pode acabar adicionando no kanabn 
              let index = newStatus.items.findIndex(it => it.id === task.id)
              if (index == -1) {
                newStatus.items.unshift(task)
                newStatus.total = newStatus.total + 1
              }
            }
          } else {
            let status = this.$refs.kanban.allStatus.find(st => st.id_text === task.status.id_text)
            if (status) {
              let index = status.items.findIndex(it => it.id === task.id)
              if (index != -1) Object.assign(status.items[index], task)
            }
          }
        }
      } else {
        let index = this.items.findIndex(it => it.id === task.id)
        if (index != -1) Object.assign(this.items[index], task)
      }
    },
    methodDeleteSocketItem (task) {
      if (this.individualFilter['properties']['exibitionType'] && this.individualFilter['properties']['exibitionType'] === 2) {
        let status = this.$refs.kanban.allStatus.find(st => st.id_text === task.status.id_text)
        if (status) {
          status.items = status.items.filter(val => val.id !== task.id)
          status.total = status.total - 1
        }
      } else {
        this.items = this.items.filter(val => val.id !== task.id)
      }
    }
  },
  sockets: {
    // EVENTOS PARA MANIPULAÇÃO DOS ITEMS
    // Evento 'addSocketItem' emitido pelo servidor quando o usuário adiciona um item.
    addSocketItem (task) {
      this.methodAddSocketItem(task)
    },
    // Evento 'editSocketItem' emitido pelo servidor quando o usuário edita algum item.
    editSocketItem (task) {
      this.methodEditSocketItem(task)
    },
    // Evento "deleteSocketItem" emitido pelo servidor quando algum item é deletado.
    deleteSocketItem (task) {
      this.methodDeleteSocketItem(task)
    },
    socketSnackbar (item) {
      if (this.beforeSocketSnackbar(item) !== false) {
        this.$store.commit('snackbar/change_values', {
          text: item.text,
          color: (item.color ? item.color : 'warning'),
          dialog: true,
          timeout: (item.timeout ? item.timeout : 5000)
        })
      }
      this.afterSocketSnackbar(item)
    },
    addSocketItemDetails (item) {
      if (this.beforeAddSocketItemDetails(item) !== false) {
        // Encontra a equipe
        let team = this.items.find((val) => {
          return val.id === item.values.team_id
        })
        // Se encontrar a equipe, adiciona o novo participantes
        if (team) {
          team[item.details].push(item.values)
        }
        // Altera também no allItems para adicionar o item mesmo se estiver filtrado.
        let allItem = this.allItems.find((val) => {
          return val.id === item.values.team_id
        })
        if (allItem) {
          allItem[item.details].push(JSON.parse(JSON.stringify(item.values)))
        }
      }
    },
    editSocketItemDetails (item) {
      if (this.beforeEditSocketItemDetails(item) !== false) {
        // Encontra a equipe e entra nos usuários dela.
        let team = this.items.find((val) => {
          return val.id === item.values.team_id
        })
        let allItem = this.allItems.find((val) => {
          return val.id === item.values.team_id
        })

        if (team) {
          // Na equipe, encontra o participante editado e atribui os novos valores a ele.
          Object.assign(team[item.details].find((val) => {
            return val.id === item.values.id
          }) || {}, item.values)
        }
        if (allItem) {
          // Altera também no allItems para adicionar o item mesmo se estiver filtrado.
          Object.assign(allItem[item.details].find((val) => {
            return val.id === item.values.id
          }) || {}, JSON.parse(JSON.stringify(item.values)))
        }
      }
    },
    deleteSocketItemDetails (item) {
      if (this.beforeDeleteSocketItemDetails(item) !== false) {
        // Encontra a equipe e entra nos usuários dela.
        let team = this.items.find((val) => {
          return val.id === item.values.team_id
        })
        let allItem = this.allItems.find((val) => {
          return val.id === item.values.team_id
        })
        if (team) {
          // Na equipe, encontra o item a ser excluído e o exclui da lista de participantes daquela equipe
          const teamIndex = team[item.details].findIndex((element) => {
            return element.id === item.values.id
          })
          team[item.details].splice(teamIndex, 1)
        }
        if (allItem) {
          // Altera também no allItems para adicionar o item mesmo se estiver filtrado.
          const allItemIndex = allItem[item.details].findIndex((element) => {
            return element.id === item.values.id
          })
          allItem[item.details].splice(allItemIndex, 1)
        }
      }
    },
    addSubTask (item) {
      // caso o level do filtro seja todas ou seja igual o level da tarefa deve inserrir normal
      if ((this.individualFilter['properties']['showTaskLevel'] == 0 || (this.individualFilter['properties']['showTaskLevel'] == 1 && item['level'] === 1) || (this.individualFilter['properties']['showTaskLevel'] == 2 && item['level'] > 1))) {
        this.methodAddSocketItem(item)
      } else {
        // Tenta encontrar a tarefa pai.
        let topTask = this.items.find((val) => {
          return val.id === item.top_id
        })
        if (!topTask) {
          // Se não encontrar a tarefa pai, verifica se a pessoa é responsável pela sub e adiciona a árvore inteira
          if (item.user_id === this.$auth.user().id) {
            this.$http.get(`api/tasks?where=id=${item.top_id}`).then((res) => {
              this.items.push(JSON.parse(JSON.stringify(res.body[0])))
              this.reloadFilter()
            })
          }
        } else {
          var treeSequence = this.changeOrderSequence(item.tree_task_sequence)
          this.recursiveAddSubTask(item, topTask, treeSequence)
        }
      }
    },
    deleteSubTask (item) {
      console.log('1')
      // caso o level do filtro seja todos ou o level do filtros seja de acordo com o level da tarefa deve inserir normal
      if (this.individualFilter['properties']['showTaskLevel'] == 0 || (this.individualFilter['properties']['showTaskLevel'] == 1 && item['level'] == 1) || (this.individualFilter['properties']['showTaskLevel'] == 2 && item['level'] > 1)) {
        console.log('2')
        this.methodDeleteSocketItem(item)
      } else {
        console.log('3')
        // Encontra a topTask na lista de tarefas do usuário
        var notParticipant = false
        var topTask = this.items.find((val) => {
          return val.id === item.top_id
        })
        if (topTask) {
          //* Se o id do usuário estiver nesse array, significa que ele não é mais participante da tarefa
          for (var prop in item.delTaskUsers) {
            if (item.delTaskUsers[prop] === this.$auth.user().id) {
              notParticipant = true
            }
          }
          //* Se o usuário não for mais participante de nenhuma tarefa da árvore, deve excluir tudo para ele
          if (notParticipant) {
            let topTaskIndex = this.items.findIndex((element) => {
              return element.id === topTask.id
            })
            this.items.splice(topTaskIndex, 1)
            return
          } else {
            //* Se ainda for participante, exclui somente a subtarefa deletada e mantem a árvore
            var treeSequence = this.changeOrderSequence(item.tree_task_sequence)
            this.recursiveDeleteSubTask(item, topTask, treeSequence)
          }
        }
      }
    },
    editSubTask (item) {
      // caso o level do filtro seja todos ou o level do filtros seja de acordo com o level da tarefa deve inserir normal
      if (this.individualFilter['properties']['showTaskLevel'] == 0 || (this.individualFilter['properties']['showTaskLevel'] == 1 && item['level'] == 1) || (this.individualFilter['properties']['showTaskLevel'] == 2 && item['level'] > 1)) {
        this.methodEditSocketItem(item)
      } else {
        // Encontra a top task
        if (this.beforeEditSubTask(item) !== false) {
          var isTaskTreeParticipant = false
          var topTask = this.items.find((val) => {
            return val.id === item.top_id
          })
          var treeSequence = this.changeOrderSequence(item.tree_task_sequence)
          if (item.old_user_id !== item.user_id) {
            for (var prop in item.participants) {
              if (item.participants[prop] === this.$auth.user().id) {
                isTaskTreeParticipant = true
              }
            }
            // Se tiver a tarefa mãe verifica se a filha está aberta para alterar
            if (topTask) {
              // caso o usuário não seja participante da tarefa mais, apaga a tarefa
              if (!isTaskTreeParticipant) {
                // Não tem mais participação na árvore da tarefa, deleta tudo
                let topTaskIndex = this.items.findIndex((element) => {
                  return element.id === topTask.id
                })
                this.items.splice(topTaskIndex, 1)
              } else {
                // Ainda tem participação, somente edita a subtarefa alterada
                this.recursiveEditSubTask(item, topTask, treeSequence)
              }
            }
          } else {
            // nem sempre tem o items para buscar as subs, no caso o kanban
            if (topTask) this.recursiveEditSubTask(item, topTask, treeSequence)
          }
        }
      }
    },
    // socket usaod para alterar a porcentagem das tarefas mães quando uma filha é finalizada
    socketQtdFinalizeSubTask (task) {
        // o kanban não possui total de subtarefas
      console.log('1', this.individualFilter['properties'], this.individualFilter['properties']['exibitionType'])
      if (this.individualFilter['properties']['exibitionType'] !== 2) {
        let treeSequence = (task.hasOwnProperty('tree_task_sequence') && task['tree_task_sequence']) ? task['tree_task_sequence'] : []
        // estrutura a sequencia para poder percorre a hierarquia
        treeSequence = this.changeOrderSequence(treeSequence)
        // verifica se a tarefa do topo está na lista de tarefas do usuário e se veio a sequencia para buscar a tarefa que deve ser alterada
        if (treeSequence) {
          let tasks = this.items
          treeSequence.forEach((task_id) => {
            // busca a tarefa para começar as buscas
            let motherTask = tasks.find((item) => { return item['id'] === task_id })
            // verifica se a tarefa encontrada é a mãe da tarefa que teve o status alterado
            // se for a mesma altera a quantidade de tarefas sub finalizadas da tarefa mãe (mothertask)
            if (motherTask['id'] === task['task_id']) {
              // se tiver o campo das tarefas finalizadas, verifica se o type é pra add(subtarefa finalizada) ou del(tarefa desfinalizada)
              motherTask['finalized_subtasks'] = motherTask['finalized_subtasks'] + (task['type'] === 'add' ? 1 : -1)
              // Caso não seja a mesma significa que ainda não encontrou a tarefa mãe, portanto continuar descendo o level
            } else {
              if (motherTask.hasOwnProperty('all_subtasks')) {
                tasks = motherTask['all_subtasks']
              }
            }
          })
        }
      }
    },
    reloadTasksAll (task) {
      // Usado quando finaliza todas as tarefas filhas ou quando finaliza a mae pela mensagem de finalização e para quando o usuário adicionar várias tarefas pelo xls ou qunado apaga um status
      this.changePageOrkanban()
    },
    reloadTasks (task) {
      // caso o usuário esteja no kanban, verifica se caso o level do filtro seja todos ou o level do filtros seja de acordo com o level da tarefa ou se o realoadtask veio da opção de finalizar a mãe, pois se sim deve atualizar os status que mudaram
      if (this.individualFilter['properties']['exibitionType'] === 2 && ((this.individualFilter['properties']['showTaskLevel'] == 0 || (this.individualFilter['properties']['showTaskLevel'] == 1 && task['level'] == 1) || (this.individualFilter['properties']['showTaskLevel'] == 2 && task['level'] > 1)) || task.hasOwnProperty('finalize_father'))) {
        // Coloca um setInterval para dar tempo do kanban carregar
        var intervalKanban = setInterval(() => {
          if (this.$refs.kanban) {
            clearInterval(intervalKanban)
            this.$refs.kanban.reloadStatus([task['task_status_id'], task['before_task_status_id']])
          }
        }, 100)
      } else if (this.individualFilter['properties']['exibitionType'] === 1 || this.individualFilter['properties']['exibitionType'] === 0) this.changePage(this.page, false, false)
    },
    // Evento geral para resolução de problemas específicos das telas. (em cada tela este evento será utilizado de uma maneira através do "methodGeneralSocket()")
    generalSocket (item) {
      this.methodGeneralSocket(item)
    },
    reloadPageModules (item) {
      if (this.beforeReloadPageModules(item) !== false) {
        this.$store.commit('dialogWarning/change_values', {
          text: item.text,
          showDialog: true
        })
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixin/socketTaskConsult.js